import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-压裂分析_数据分析",
  "use": "icon-压裂分析_数据分析-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-压裂分析_数据分析\">\n<rect y=\"14.3\" width=\"16\" height=\"1\" />\n<path d=\"M4.5,13h-3V6.2h3V13z M2.5,12h1V7.2h-1V12z\" />\n<path d=\"M14.5,13h-3V6.2h3v3.2c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V7.2h-1V12h1v-0.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V13z\n\t\" />\n<path d=\"M9.5,13h-3V0.2h3V13z M7.5,12h1V1.2h-1V12z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol